import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    Grid,
    Typography,
    useTheme,
} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import toast from '../../../shared/Toast';
const { REACT_APP_BASE_URL } = process.env;

const CalendarLinkModal = ({
    onClose,
    open,
    contractorCalendarId,
    userCalendarId,
}: {
    onClose: () => void;
    open: boolean;
    contractorCalendarId: string;
    userCalendarId: string;
}) => {
    const contractorCalendar = `${REACT_APP_BASE_URL}/calendar/contractors/${contractorCalendarId}.ics`;
    const userCalendar = `${REACT_APP_BASE_URL}/calendar/contractorUsers/${userCalendarId}.ics`;

    const theme = useTheme();

    async function copyTextToClipboard(url: string) {
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(url);
        } else {
            return document.execCommand('copy', true, url);
        }
    }

    const handleCalendarCopyClick = (calendar: string) => {
        copyTextToClipboard(calendar)
            .then(() => {
                toast.success('Link copied to clipboard');
            })
            .catch((err) => {
                console.error('Failed to copy text:', err);
                toast.error('Failed to copy. Please try again.');
            });
    };

    return (
        <Dialog open={open}>
            <DialogTitle>
                Sync Your Calendar
                <IconButton
                    aria-label='close'
                    onClick={() => onClose()}
                    size='small'
                    sx={{ color: 'text.primary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography
                        sx={{
                            marginBottom: '15px',
                        }}
                    >
                        You can use the link{contractorCalendarId && 's'} below
                        to sync your jobs with an external calendar such as
                        Google Calendar or Outlook.
                    </Typography>
                    <Typography
                        sx={{
                            marginBottom: '25px',
                        }}
                    >
                        {contractorCalendarId
                            ? 'These links provide a read-only view and are '
                            : 'This link provides a read-only view and is '}
                        refreshed based on the external calendar's update
                        frequency. Only accepted jobs are included.
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button
                                variant='outlined'
                                fullWidth
                                sx={{
                                    border: `${theme.palette.lightGrey.main} solid 1px`,
                                    height: '39px',
                                }}
                                onClick={() =>
                                    handleCalendarCopyClick(userCalendar)
                                }
                            >
                                <ContentCopyIcon
                                    sx={{
                                        marginRight: '8px',
                                    }}
                                />
                                <Typography
                                    sx={{
                                        color: 'text.primary',
                                    }}
                                >
                                    {contractorCalendarId
                                        ? 'My Calendar Link'
                                        : ' Copy Link'}
                                </Typography>
                            </Button>
                        </Grid>
                        {contractorCalendarId && (
                            <Grid item xs={12}>
                                <Button
                                    variant='outlined'
                                    fullWidth
                                    sx={{
                                        border: `${theme.palette.lightGrey.main} solid 1px`,
                                        height: '39px',
                                    }}
                                    onClick={() =>
                                        handleCalendarCopyClick(
                                            contractorCalendar,
                                        )
                                    }
                                >
                                    <ContentCopyIcon
                                        sx={{
                                            marginRight: '8px',
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            color: 'text.primary',
                                        }}
                                    >
                                        Organisation Calendar Link
                                    </Typography>
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default CalendarLinkModal;
